import * as React from "react";

function ClockSvg(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.291 11.042A7.294 7.294 0 0110 18.333a7.294 7.294 0 01-7.292-7.291A7.294 7.294 0 0110 3.75a7.294 7.294 0 017.291 7.292zM10 6.667v4.166"
        stroke="#7E7E7E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 1.667h5"
        stroke="#7E7E7E"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ClockSvg;
